import React from "react";
import { useI18n } from "../lib/i18n";

export const BrandFooter = () => {
    const { t } = useI18n();
    return (
        <footer
            data-testid="brand-footer"
            className="pt-8 pb-6 flex flex-col items-center gap-3"
        >
            <div
                data-testid="footer-legal-links"
                className="flex items-center gap-4 text-xs sm:text-sm font-display font-semibold text-zinc-500"
            >
                <a
                    data-testid="footer-link-privacy"
                    href="https://www.makrolog.de/home/#/datenschutz"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-zinc-900 hover:underline underline-offset-2 transition"
                >
                    {t("footer_privacy")}
                </a>
                <span className="text-zinc-300" aria-hidden>
                    ·
                </span>
                <a
                    data-testid="footer-link-imprint"
                    href="https://www.makrolog.de/home/#/impressum"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:text-zinc-900 hover:underline underline-offset-2 transition"
                >
                    {t("footer_imprint")}
                </a>
            </div>
        </footer>
    );
};
